import { useState, useEffect } from 'react';
import { authenticatedFetch } from '../../../utils/api';

const useQueryData = ({ preloadedData, urlParams, setLoading }) => {
    const pre = preloadedData;

    const [queryData, setQueryData] = useState(() => pre?.queries?.item1 || []);
    const [queryDataLoaded, setQueryDataLoaded] = useState(() => !!pre?.queries?.item1);
    const [queryResolutionTypes, setQueryResolutionTypes] = useState(() => pre?.resolutionTypes?.resolutionTypes || []);

    const loadQueryDataBackground = async () => {
        if (queryDataLoaded) return;
        try {
            const res = await authenticatedFetch('/ManagerReport/GetSubmittedQueries', {
                method: 'POST',
                body: JSON.stringify({}),
            });
            const result = await res.json();
            if (result.message == null) {
                setQueryData(result.item1);
                setQueryDataLoaded(true);
            }
        } catch (ex) {
            console.log('Background query load failed:', ex);
            const queryId = urlParams.get('queryid');
            if (queryId) {
                setLoading(false);
            }
        }
    };

    // Load on mount
    useEffect(() => {
        loadQueryDataBackground();
    }, []);

    // Clear loading when queryId present and data arrives
    useEffect(() => {
        const queryId = urlParams.get('queryid');
        if (queryId) {
            setLoading(false);
        }
    }, [queryData]);

    return {
        queryData,
        setQueryData,
        queryDataLoaded,
        queryResolutionTypes,
        setQueryResolutionTypes,
        loadQueryDataBackground,
    };
};

export default useQueryData;
